import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getBank, Icon, SimpleModal, toast } from '@livable/saas-react-components';
import { Typography, List, ListItem, RadioGroup, FormControlLabel, Radio, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useStore } from 'src/stores';
import useStyles from './styles';
const ChangePaymentMethodModal = observer(_ref => {
  var _store$payment$autopa, _store$payment$autopa2;
  let isBackupMethod = _ref.isBackupMethod,
    customTrigger = _ref.customTrigger;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    autoPayMethodId = _useState2[0],
    setAutoPayMethodId = _useState2[1];
  const _useState3 = useState((_store$payment$autopa = store.payment.autopayMethod) === null || _store$payment$autopa === void 0 ? void 0 : _store$payment$autopa.id),
    _useState4 = _slicedToArray(_useState3, 2),
    defaultId = _useState4[0],
    setDefaultId = _useState4[1];
  const setAutopayMethod = async data => {
    const resp = await store.payment.setAutopayMethodAsync.run(data);
    return resp;
  };
  useEffect(() => {
    if (autoPayMethodId) {
      setAutopayMethod({
        paymentMethodId: autoPayMethodId
      }).then(resp => {
        if (resp && resp.isSuccessful) {
          const newDefualtMethod = store.payment.paymentMethods.find(method => method.id === autoPayMethodId);
          store.payment.setAutopayMethodAfterLoad({
            response: _objectSpread({}, newDefualtMethod)
          });
          toast('success', {
            body: ['Default method successfully set']
          }); // ? i18n
          setAutoPayMethodId(null);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoPayMethodId]);
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '283-change-payment-method-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('buttons.change')));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: customTrigger !== undefined ? customTrigger : defaultTrigger || null,
    title: isBackupMethod ? t('subscriptions.backup_payment_method') : t('subscriptions.default_payment_method'),
    rightButton: /*#__PURE__*/React.createElement(Button, {
      disabled: defaultId === ((_store$payment$autopa2 = store.payment.autopayMethod) === null || _store$payment$autopa2 === void 0 ? void 0 : _store$payment$autopa2.id),
      onClick: () => setAutoPayMethodId(defaultId),
      variant: "contained",
      'custom-attribute': '284-change-payment-method-modal'
    }, t('buttons.save_changes'))
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('subscriptions.select_method'), " ", isBackupMethod ? t('subscriptions.backup') : t('general.default')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(RadioGroup, {
    onChange: e => setDefaultId(e.target.value),
    value: defaultId
  }, store.payment.paymentMethods.map(method => /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Radio, null),
    key: method.id,
    value: method.id,
    label: "".concat(t('general.use'), " ").concat(getBank(method.brand).title, " ****").concat(method.last4)
  })))))));
});
ChangePaymentMethodModal.propTypes = {
  trigger: PropTypes.node
};
export default ChangePaymentMethodModal;